import { ThemeProvider } from '@mui/material/styles';
import { useUserContext } from 'common/contexts/UserContext';
import BlueCargoLogo from 'components/BlueCargoLogo';
import { useLogout } from 'ducks/user';
import * as React from 'react';
import { themeProvider } from 'themeProvider';
import { Button } from '@mui/material';
import styles from '../../styles/typography.module.css';

interface Props {
  children?: React.ReactNode | undefined;
  className?: string;
  noLogo?: boolean;
}

/**
 * Root page component used for our sign in / sign up related views
 */
export const SignUpTemplate: React.FC<Props> = (props) => {
  const { user } = useUserContext();
  const handleLogout = useLogout();

  return (
    <ThemeProvider theme={themeProvider}>
      <div
        className={`w-screen h-screen p-8 bg-white overflow-auto relative ${styles.font} ${
          props.className || ''
        }`}
      >
        <div className="flex justify-between align-center">
          {!props.noLogo && <BlueCargoLogo variant="larger-blue" />}
          {user && (
            <div className="text-gray-900 flex items-center">
              <Button className="underline normal-case text-gray-900" onClick={handleLogout}>
                Log out
              </Button>
            </div>
          )}
        </div>
        {props.children}
      </div>
    </ThemeProvider>
  );
};
